module.exports = __webpack_public_path__ + "img/folder-download.35060da0.svg";